var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/util');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');

import Swiper, { Navigation, Pagination } from 'swiper';


import AOS from 'aos';


import Mmenu from 'mmenu-js';

// import Swiper from 'swiper/bundle';

$(function() {

    const mmenu = new Mmenu('#mob-menu', {
        'extensions': [
            // "pagedim-black"
        ],
    }, {
        // configuration
        offCanvas: {
            page: {
                 selector: '#offcanvas'
            }
        },
        classNames: {
            selected: "active"
        }
    });

    const mmenuApi = mmenu.API;
    mmenuApi.bind('open:after', function(){
        $('.btn-menu').addClass('open').attr('href','#offcanvas');
    });
    mmenuApi.bind('close:after', function(){
        $('.btn-menu').removeClass('open').attr('href','#mob-menu');
    });

    AOS.init({
        once: true,
    });


    // $(window).on('scroll load resize', function() {

        // if($(window).width() >= 768){
        //     //Hero images panel
        //     var navHeight = $("#home-content").outerHeight();
        //     var windowHeight = window.innerHeight - navHeight;

        //     $('#hero-video').css('height', windowHeight )

        // }else{
        //     $('#hero-video').css('height', 'auto' )
        // }

    // });



    $(window).on('resize load scroll', function() {
    // var headerHeight = $('.navbar--main').outerHeight();
        var scroll = $(window).scrollTop();

        if (scroll >= 40 ) {  //scroll top menu out of view
            $('.navbar--main').addClass("down");
        } else {
            $('.navbar--main').removeClass("down");
        }
    });

    //content slider & project slider

    let contentSwiper = new Swiper(".contentSlider", {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });


    //projects slider
    let projectsSwiper = new Swiper(".panelProjects", {
        modules: [Navigation],
        slidesPerView: "auto",
        // autoHeight: true,
        spaceBetween: 30,

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {

            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    //testimonials slider
    let testiSwiper = new Swiper(".panelTestimonials", {
        modules: [Navigation],
        slidesPerView: "auto",
        // autoHeight: true,
        spaceBetween: 30,

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {

            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });



    let pgImgTopSwiper = new Swiper(".pageImagesTop", {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction",
        },
    });


    let pageImageSwiper = new Swiper(".pageImages", {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 0,

        breakpoints: {
            992: {
                slidesPerView: 1
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
    });

    scrollToFormElementID();

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }
/*
    $('.btn-collapse').on('click', function() {
        $(this).find('.feather').toggleClass('d-none');
    }); */

    var video = document.getElementById("heroVideo");

    $('#btn-pause').on('click', function() {
        video.pause();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-play").addClass('d-flex').removeClass('d-none');
    });

    $('#btn-play').on('click', function() {
        video.play();
        $(this).addClass('d-none').removeClass('d-flex');
        $("#btn-pause").addClass('d-flex').removeClass('d-none');
    });

    //moved to vue component
    $('.btn-show-filters, #sidebar-filters-bg').on('click', function() {
        $('#sidebar-filters, .sidebar-filters-bg').toggleClass('show');
        // $().toggleClass('show');
        $("html, body").animate({
             scrollTop: 0
        }, 300);

        return false;
    });


    $('.btn-group-input').on('change', function (e) {
        let elm = e.target;
        let checked = e.target.checked;

        $(elm).closest('.btn-group').find('.btn-group-label').removeClass('active');
        $(elm).closest('.btn-group').find('.btn-group-input').each(function (idx, elm) {
            elm.checked = false;
        });

        if (checked) {
            $(elm).closest('.btn-group-label').addClass('active');
            $(elm).closest('.btn-group').find('.btn-group-value').attr('value', e.target.value);
        } else {
            $(elm).closest('.btn-group-label').removeClass('active');
            $(elm).closest('.btn-group').find('.btn-group-value').attr('value', '');
        }
    });

    $('.selectpicker').selectpicker({
        style: 'btn-select',
    });

    // $('.page-scroll').bind('click', function(event) {
    //     var $anchor = $(this);
    //     var elId = $anchor.attr('href').replace('/', '');

    //     $('html, body').stop().animate({
    //         scrollTop: $(elId).offset().top
    //     }, 750, 'easeInOutExpo');

    //     event.preventDefault();
    // });

    // $('.scrollup').click(function() {
    //      $("html, body").animate({
    //          scrollTop: 0
    //      }, 600);
    //      return false;
    //  });

    //tabbed url
   /*  if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    }); */

    // $('[data-toggle="tooltip"]').tooltip();

    // add custom hover toggle for nav links
   /*  $('[data-toggle-hover]').on('hover',function() {
        var $this = $(this);
        var targetClass = $this.data('toggle-hover');
        var $target = $this.closest('.' + targetClass).find('.' + targetClass + '-menu');
        $target.addClass('show');
        $target.parent().off('mouseleave').on('mouseleave', function() {
            $target.removeClass('show');
        });
    }); */

    //dropdown inside dropdown
   /*  $('.dropdown.dropdown-keep-open').on({
        'mouseleave': function() {
            this.closable = true;
        },
        'mouseenter': function() {
            this.closable = false;
        },
        'hide.bs.dropdown': function(e) {
            if ($(e.target).hasClass('dropdown-keep-open')) {
                return this.closable;
            }

            return true;
        },
    }) */

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    // $.extend(true, $.fn.datetimepicker.defaults, {
    //     icons: {
    //         time: 'fa fa-clock',
    //         date: 'fa fa-calendar',
    //         up: 'fa fa-arrow-up',
    //         down: 'fa fa-arrow-down',
    //         previous: 'fa fa-chevron-left',
    //         next: 'fas fa-chevron-right',
    //         today: 'fa fa-calendar-check',
    //         clear: 'fa fa-calendar-times',
    //         close: 'fa fa-times-circle'
    //     }
    // });
   /*  $('.datepicker-start').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        //debug:true,
    });
    $('.datepicker-end').datetimepicker({
        format: 'DD/MM/YYYY',
        showTodayButton: true,
        showClear: true,
        useCurrent: false, //Important! See issue #1075
        //debug:true,
    });

    $('.datepicker-start').on("dp.change", function(e) {
        $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    });
    $('.datepicker-end').on("dp.change", function(e) {
        $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    });
 */
    // $('.reset-filter').on('click', function(e) {
    //     e.preventDefault();
    //     $(this).closest('form').find('input[type=text]').val('');
    // });


});

// var setCookie = function(name, value, expiry) {
//     var exdate = new Date();
//     exdate.setTime(exdate.getTime() + expiry * 1000);
//     var c_value = escape(value) + ((expiry == null) ? "" : "; expires=" + exdate.toUTCString());
//     document.cookie = name + "=" + c_value + '; path=/';
// };

// var getCookie = function(name) {
//     var i, x, y, ARRcookies = document.cookie.split(";");
//     for (i = 0; i < ARRcookies.length; i++) {
//         x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
//         y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
//         x = x.replace(/^\s+|\s+$/g, "");
//         if (x == name) {
//             return y ? decodeURI(unescape(y.replace(/\+/g, ' '))) : y; //;//unescape(decodeURI(y));
//         }
//     }
// };



// scroll window to form error element and offset fixed header height
function scrollToFormElementID() {
    // console.log('scrollToFormElementID', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var El = window.location.hash;
        if ($(El).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(El).scrollTop());

                // offset
                var offsetSize = $('#main-nav').height() ;
                // animate scrollto
                $('html, body').animate({ scrollTop: $(El).offset().top - offsetSize }, 300);


        }
    }
}

window.trackingEvent = function trackingEvent(eventName, data) {
    // console.log(eventName, data);
    let event = new CustomEvent(eventName, {
        detail: data,
    });
    window.dispatchEvent(event);
}

window.goBack = () => {
    window.history.go(-1);
}

window.dispatchEvent(new CustomEvent('init'));
window.dispatchEvent(new CustomEvent('js-init'));